import { HStack, Button, Icon, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  mt = 6,
}: {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  mt?: number | string;
}) => {
  if (totalPages < 1) return null;

  const generatePages = () => {
    const pages = [];

    pages.push(
      <Button
        key={1}
        onClick={() => onPageChange(1)}
        size="sm"
        variant={currentPage === 1 ? "solid" : "outline"}
        colorScheme={currentPage === 1 ? "blue" : "gray"}
        w="32px"
        h="32px"
        p={0}
      >
        1
      </Button>
    );

    if (currentPage > 4) {
      pages.push(
        <Text key="left-dots" fontSize="sm" px={1}>
          ...
        </Text>
      );
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(
        <Button
          key={i}
          onClick={() => onPageChange(i)}
          size="sm"
          variant={currentPage === i ? "solid" : "outline"}
          colorScheme={currentPage === i ? "blue" : "gray"}
          w="32px"
          h="32px"
          p={0}
        >
          {i}
        </Button>
      );
    }

    if (currentPage < totalPages - 3) {
      pages.push(
        <Text key="right-dots" fontSize="sm" px={1}>
          ...
        </Text>
      );
    }

    if (totalPages > 1) {
      pages.push(
        <Button
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          size="sm"
          variant={currentPage === totalPages ? "solid" : "outline"}
          colorScheme={currentPage === totalPages ? "blue" : "gray"}
          w="32px"
          h="32px"
          p={0}
        >
          {totalPages}
        </Button>
      );
    }

    return pages;
  };

  return (
    <HStack spacing={1} mt={mt} justify="end">
      <Button
        size="sm"
        onClick={() => onPageChange(currentPage - 1)}
        isDisabled={currentPage === 1}
        w="32px"
        h="32px"
        p={0}
      >
        <Icon as={ChevronLeftIcon} />
      </Button>

      {generatePages()}

      <Button
        size="sm"
        onClick={() => onPageChange(currentPage + 1)}
        isDisabled={currentPage === totalPages}
        w="32px"
        h="32px"
        p={0}
      >
        <Icon as={ChevronRightIcon} />
      </Button>
    </HStack>
  );
};

export default Pagination;
